const ADMIN_TRANSACTIONS = {
  SET_TRANSACTIONS_QUERY: 'SET_ADMIN_TRANSACTIONS_QUERY',
};

export default ADMIN_TRANSACTIONS;
